export default {"src":"/_next/static/media/_ovation.e01eaa85.svg","height":19,"width":18};